import Customer from "@/customer/interfaces/Customer";

/**
 * @interface SupportProgram
 *
 * @property {number} id - The program id.
 * @property {Program} program - The parent program data.
 */
export enum SupportProgramAddonSlug {
    Pets = 'pets',
    VaccinationTimeline = 'vaccination-timeline',
    FLOWCHART = 'flowchart',
    FLOWCHART_GROUP = 'flowchart-group',
    SURVEY = 'survey'
}

export interface BaseSupportProgramAddon {
    /** The addon slug. */
    slug: SupportProgramAddonSlug;
    /** The addon payload. */
    payload: object;
}

export interface VaccinationTimelineAddon extends BaseSupportProgramAddon {
    slug: SupportProgramAddonSlug.VaccinationTimeline;
    payload: {
        slug: string;
    }
}

export interface PetsAddon extends BaseSupportProgramAddon {
    slug: SupportProgramAddonSlug.Pets;
    payload: never
}

export interface FlowchartAddon extends BaseSupportProgramAddon {
    slug: SupportProgramAddonSlug.FLOWCHART;
    payload: {
        slug: string;
        heading: string;
        description: string | null;
    }
}

export interface FlowchartAddonGroup extends BaseSupportProgramAddon {
    slug: SupportProgramAddonSlug.FLOWCHART_GROUP;
    payload: {
        heading: string;
        description: string;
        charts: FlowchartAddon['payload'][]
    };
}

export interface SurveyAddon extends BaseSupportProgramAddon {
    slug: SupportProgramAddonSlug.SURVEY;
    payload: {
        heading: string;
        description: string | null;
        survey_slug: string;
    }
}

export interface AddonComponentsProps<T extends BaseSupportProgramAddon> {
    customer: Customer;
    consumerKey: string;
    /** The support program the addon belongs to, for its consumer data route. */
    supportProgramId: number;
    payload: T['payload']
}
